// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const ComissionMasterList    = lazy(() => import('../../views/comissionMaster/list'))
const ComissionMaster = [
  {
    path: 'comissionMaster/list',
    element: <ComissionMasterList />
  }
]


export default ComissionMaster